import uniqBy from 'lodash.uniqby';

const weekDay = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];

const weekDayFull = [
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
  'Воскресенье',
];

const splitting = (scheduleItem, returnArray, splitSymbol) => {
  if (scheduleItem.daysOfWeek.search(splitSymbol) !== -1) {
    const firstSplitItems = scheduleItem.daysOfWeek.split(splitSymbol);
    const firstIndex = weekDay.indexOf(firstSplitItems[0]);
    const lastIndex = weekDay.indexOf(firstSplitItems[1]);

    weekDay.forEach((day, index) => {
      if (index >= firstIndex && index <= lastIndex) {
        returnArray.push({
          ...scheduleItem,
          daysOfWeek: day,
          daysOfWeekFull: weekDayFull[index],
        });
      }
    });
  }

  return returnArray;
};

const getCurrentDay = schedules => {
  const date = new Date();
  const currentDay = date.getDay();
  const workDescriptionUniq = uniqBy(schedules, route => route.workDescription);
  const isSameSchedule = workDescriptionUniq.length === 1;

  if (isSameSchedule) {
    return `Работает ежедневно, ${schedules[0].workDescription}`;
  }

  if (currentDay === 0) {
    return `${schedules[6].daysOfWeekFull}, ${schedules[6].workDescription}`;
  }
  return `${schedules[currentDay - 1].daysOfWeekFull}, ${
    schedules[currentDay - 1].workDescription
  }`;
};

const formatScheduleDate = schedules => schedules.map(item => {
    const workDescriptionSplitting = item.workDescription.split('-');
    const workDescriptionSplittingTrimItems = workDescriptionSplitting.map(
      item => item.trim()
    );
    return {
      ...item,
      workDescription: workDescriptionSplittingTrimItems.join('–'),
    };
  });

const serializeSchedulePoint = schedule => {
  let serializeSchedules = [];

  schedule.forEach(scheduleItem => {
    serializeSchedules = splitting(scheduleItem, serializeSchedules, '-');
    serializeSchedules = splitting(scheduleItem, serializeSchedules, ',');
    if (
      scheduleItem.daysOfWeek.search('-') === -1 &&
      scheduleItem.daysOfWeek.search(',') === -1
    ) {
      serializeSchedules.push({
        ...scheduleItem,
        daysOfWeekFull: weekDayFull[weekDay.indexOf(scheduleItem.daysOfWeek)],
      });
    }
  });

  serializeSchedules = formatScheduleDate(serializeSchedules);

  const currentDay = getCurrentDay(serializeSchedules);

  return {
    serializeSchedules,
    currentDay,
  };
};

export default serializeSchedulePoint;
